import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';

function showCustomToast(message, title = 'Error') {
    toast.error(
        <div>
            <span className="toast-title">{title}</span>
            {message}
        </div>,
        {
            className: 'custom-toast'
        }
    );
}

export const getUserProfile = createAsyncThunk('dashboardSlice/getUserProfile', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/auth/getProfile', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getStatistic = createAsyncThunk('dashboardSlice/getStatistic', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/getMyStatistic', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getCashCard = createAsyncThunk('dashboardSlice/getCashCard', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/getMyCashCard', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getCardLists = createAsyncThunk('dashboardSlice/getCardLists', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/getCardList', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getLinkedBankLists = createAsyncThunk('dashboardSlice/getLinkedBankLists', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/getLinkBank', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getBankList = createAsyncThunk('dashboardSlice/getBankList', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/getBankList', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getFaqs = createAsyncThunk('dashboardSlice/getFaqs', async () => {
    try {
        showLoader(true);
        let response = await axios.post('/getFAQ', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createSaveCreditCardUser = createAsyncThunk(
    'dashboardSlice/createSaveCreditCardUser',
    async (data, { dispatch, rejectWithValue }) => {
        try {
            showLoader(true);
            let response = await axios.post('/saveCareditCard', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            // toast.success(response?.data?.message || 'CreditCard added successfully.');
            showLoader(false);
            return Promise.resolve(response.data.data);
        } catch (err) {
            showLoader(false);
            showCustomToast(err?.response?.data?.message || 'Something went wrong!');
            return rejectWithValue(err);
        }
    }
);

export const getLoanCalculation = createAsyncThunk('dashboardSlice/getLoanCalculation', async (data, { dispatch, rejectWithValue }) => {
    try {
        showLoader(true);
        let response = await axios.post('/getLoanCalculation', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // toast.success(response?.data?.message || 'CreditCard added successfully.');
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err);
    }
});

export const CreateLoan = createAsyncThunk('dashboardSlice/CreateLoan', async (data, { dispatch, rejectWithValue }) => {
    try {
        showLoader(true);
        let response = await axios.post('/getLoanCalculation', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // toast.success(response?.data?.message || 'CreditCard added successfully.');
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err);
    }
});

export const createTransaction = createAsyncThunk('dashboardSlice/createTransaction', async (data, { dispatch, rejectWithValue }) => {
    try {
        showLoader(true);
        let response = await axios.post('/transaction', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // toast.success(response?.data?.message || 'CreditCard added successfully.');
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err);
    }
});

export const bankDetailsAdd = createAsyncThunk('dashboardSlice/bankDetailsAdd', async (data, { dispatch, rejectWithValue }) => {
    try {
        showLoader(true);
        let response = await axios.post('/linkBank', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // toast.success(response?.data?.message || 'CreditCard added successfully.');
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err);
    }
});

export const activeCashCardUser = createAsyncThunk('dashboardSlice/activeCashCardUser', async (data, { dispatch, rejectWithValue }) => {
    try {
        showLoader(true);
        let response = await axios.post('/activeCashCard', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err);
    }
});

export const CashCardChangePinUser = createAsyncThunk(
    'dashboardSlice/CashCardChangePinUser',
    async (data, { dispatch, rejectWithValue }) => {
        try {
            showLoader(true);
            let response = await axios.post('/updateCashCardPin', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            showLoader(false);
            return Promise.resolve(response.data.data);
        } catch (err) {
            showLoader(false);
            showCustomToast(err?.response?.data?.message || 'Something went wrong!');
            return rejectWithValue(err);
        }
    }
);

export const updateUserProfile = createAsyncThunk('dashboardSlice/updateUserProfile', async (data, { dispatch, rejectWithValue }) => {
    try {
        showLoader(true);
        let response = await axios.post('/auth/updateProfile', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // toast.success(response?.data?.message || 'Profile updated successfully.');
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        // showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err);
    }
});

export const updateCashCardLock = createAsyncThunk('dashboardSlice/updateCashCardLock', async (data, { dispatch, rejectWithValue }) => {
    try {
        showLoader(true);
        let response = await axios.post('/updateCashCardLock', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // toast.success(response?.data?.message || 'Profile updated successfully.');
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        // showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err);
    }
});

export const placeOrderCashCard = createAsyncThunk('dashboardSlice/placeOrderCashCard', async (data, { dispatch, rejectWithValue }) => {
    try {
        showLoader(true);
        let response = await axios.post('/placeOrderCashCard', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // toast.success(response?.data?.message || 'Profile updated successfully.');
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        // showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err);
    }
});

export const logOutUser = createAsyncThunk('dashboardSlice/logOutUser', async () => {
    try {
        showLoader(true);
        let response = await axios.post('/auth/logout', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const readNotification = createAsyncThunk('dashboardSlice/readNotification', async () => {
    try {
        showLoader(true);
        let response = await axios.post('/readNotification', {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateKyc = createAsyncThunk('dashboardSlice/updateKyc', async (data) => {
    try {
        showLoader(true);
        let response = await axios.post('/auth/kycUpdate', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // toast.success(response?.data?.message || 'Kyc updated successfully.');
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const changePassword = createAsyncThunk('dashboardSlice/changePassword', async (data) => {
    try {
        showLoader(true);
        let response = await axios.post('/auth/changePassword', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // toast.success(response?.data?.message || 'Kyc updated successfully.');
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message);
        return Promise.reject(err);
    }
});

export const deleteCreditCard = createAsyncThunk('dashboardSlice/deleteCreditCard', async (data) => {
    try {
        showLoader(true);
        let response = await axios.post('/removeCareditCard', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // toast.success(response?.data?.message || 'Kyc updated successfully.');
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getTransaction = createAsyncThunk('dashboardSlice/getTransaction', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/getWallet', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        showCustomToast(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const dashboardSlice = createSlice({
    name: 'dashboardSlice',
    initialState: {
        data: {},
        faq: [],
        cardList: [],
        linkedBank: [],
        allBankList: [],
        transaction: [],
        statistic: []
    },
    extraReducers: (builder) => {
        builder.addCase(getUserProfile.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getLinkedBankLists.fulfilled, (state, action) => {
            state.linkedBank = action.payload;
            return;
        });
        builder.addCase(getBankList.fulfilled, (state, action) => {
            state.allBankList = action.payload;
            return;
        });
        builder.addCase(getCardLists.fulfilled, (state, action) => {
            state.cardList = action.payload;
            return;
        });
        builder.addCase(getFaqs.fulfilled, (state, action) => {
            state.faq = action.payload;
            return;
        });
        builder.addCase(getCashCard.fulfilled, (state, action) => {
            state.cashCard = action.payload;
            return;
        });
        builder.addCase(getTransaction.fulfilled, (state, action) => {
            state.transaction = action.payload;
            return;
        });
        builder.addCase(getStatistic.fulfilled, (state, action) => {
            state.statistic = action.payload;
            return;
        });
        builder.addCase(getLoanCalculation.fulfilled, (state, action) => {
            state.loan = action.payload;
            return;
        });
    }
});

export default dashboardSlice.reducer;
